export default __webpack_public_path__ + "static/media/two_two.966e2b34.png";